import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import { FormStatus } from '@atlassian/proforma-common-core/form-system-models';
import { useFormIndexState, useSelectedFormStoreState } from '../../../../../controllers/form-index';
import { messages } from './messages';
import { useHandleCancelEditOld } from './utils/use-handle-cancel-edit';

// Component that provides submit, save and cancel buttons to be displayed at the top and bottom of an expanded form
// card. Save/submit state is not contained in this component - instead, the parent FormCardBody holds it so that state
// can be synchronized across both instances in a FormCardBody.
export const EditButtons = ({
  isSubmitting,
  isSaving,
  onSubmit,
  onSave,
  onCancel
}) => {
  const {
    permissions
  } = useFormIndexState();
  const {
    selectedFormStore: formStore
  } = useSelectedFormStoreState();
  // formStore is typed nullable - but we never render this component in the parent if it's null, so we can just render
  // nothing to make TypeScript happy.
  if (!formStore) return null;
  return /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    isDisabled: isSaving || isSubmitting,
    onClick: onCancel
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.cancel)), permissions.save && /*#__PURE__*/React.createElement(LoadingButton, {
    isLoading: isSaving,
    isDisabled: !formStore.answersModified || isSaving || formStore.isUploadingMedia || formStore.status !== FormStatus.Open,
    onClick: onSave
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.save)), permissions.submit && /*#__PURE__*/React.createElement(LoadingButton, {
    isLoading: isSubmitting,
    appearance: "primary",
    isDisabled: isSubmitting || formStore.isUploadingMedia || formStore.status !== FormStatus.Open && !formStore.answersModified,
    onClick: onSubmit
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.submit)));
};